import { DefaultButton } from '@fluentui/react';
import React from 'react';
import { Field, Form } from 'react-final-form';
import './SearchForm.scss';

interface ISearchFormProps {
  initialValues: {
    query: string;
  };
  onSubmit(event: any): void;
}

const required = (value: string) => (value ? undefined : 'Required');

const SearchForm = (props: ISearchFormProps) => {
  const { initialValues, onSubmit } = props;
  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form
          id="search-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(e);
          }}
        >
          <label htmlFor="query"></label>
          <Field
            placeholder="Find a nonprofit status by its legal name, nonprofit ID, transaction ID, tenant ID, domain name or agent email"
            id="query"
            name="query"
            component="input"
            type="text"
            className="inputfield"
            validate={required}
          />
          <div id="submitButton">
            <DefaultButton type="submit">Search</DefaultButton>
          </div>
        </form>
      )}
    />
  );
};

export default SearchForm;
